import { render } from "./PrivacyPolicyTextContent.vue?vue&type=template&id=463ecd5a&scoped=true"
const script = {}

import "./PrivacyPolicyTextContent.vue?vue&type=style&index=0&id=463ecd5a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463ecd5a"]])

export default __exports__